import React from 'react';
import { TimePickerSC } from './date-time-picker.styled';
import RCPicker, { PickerProps as OriginalProps } from 'rc-picker';

import enUS from 'rc-picker/lib/locale/en_US';
import skSK from 'rc-picker/lib/locale/sk_SK';
import csCZ from 'rc-picker/lib/locale/cs_CZ';

import generateFns from 'rc-picker/lib/generate/dateFns';
import generateMoment from 'rc-picker/lib/generate/moment';

import { ReactComponent as SuperNextIcon } from '../../../../assets/svg/pickers/picker_super_next.svg';
import { ReactComponent as NextIcon } from '../../../../assets/svg/pickers/picker_next.svg';
import { ReactComponent as SuperPrevIcon } from '../../../../assets/svg/pickers/picker_super_prev.svg';
import { ReactComponent as PrevIcon } from '../../../../assets/svg/pickers/picker_prev.svg';
import { useSelector } from 'react-redux';
import TStore from '../../../../types/store';

type TPickerType = <T extends any>(
  props: DateTimePickerProps<T> & React.RefAttributes<RCPicker<T>>,
) => JSX.Element;

type TO_OMIT =
  | 'nextIcon'
  | 'superNextIcon'
  | 'prevIcon'
  | 'superPrevIcon'
  | 'locale'
  | 'generateConfig';

type DateTimePickerProps<T> = Omit<OriginalProps<T>, TO_OMIT> & {
  locale?: 'sk' | 'en' | 'cs';
  generateConfig: 'moment' | 'dateFns';
  kind?: 'inline' | 'bubble';
};

const DateTimePicker = <T extends any>(
  { locale, generateConfig = 'moment', ...rest }: DateTimePickerProps<T>,
  ref?: React.Ref<RCPicker<T>>,
) => {
  const lang = useSelector((state: TStore) => locale || state.app.currentLang);

  const langFile = React.useMemo(() => {
    switch (lang) {
      case 'cs':
        return csCZ;
      case 'en':
        return enUS;
      default:
        return skSK;
    }
  }, [lang]);

  return (
    // @ts-ignore
    <TimePickerSC
      {...rest}
      ref={ref as any}
      locale={langFile}
      generateConfig={(generateConfig === 'moment' ? generateMoment : generateFns) as any}
      nextIcon={<NextIcon />}
      superNextIcon={<SuperNextIcon />}
      prevIcon={<PrevIcon />}
      superPrevIcon={<SuperPrevIcon />}
    />
  );
};

export default React.forwardRef(DateTimePicker) as TPickerType;
